import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ModalWrapper } from "./style";
import ContextDashboard from '../../Context/ContextDashboard';
import { getStorage } from "../../Utils/common";
import { Helmet } from "react-helmet";

const Modal = ({ onClose, msg, state }) => {
  const navigate = useNavigate();
  const { handleEvent } = useContext(ContextDashboard);

  const utm_source = getStorage('utm_source');
  const eligibility = getStorage('eligibility');
  console.log('hi', eligibility);

  // Function to handle the "Process" button click
  const handleProcessClick = () => {
    navigate("/my-dashboard/eligibility");
  };

  // Function to handle the "OK" button click
  const handleOkClick = () => {
    onClose(); // Close modal if not eligible
  };

  useEffect(() => {
 
    // Trigger Whistle Pixel of valueleaf only if utm_source === 'value_leaf' and eligibility == 1
    const sendWhistlePixel = () => {
      const clickId = getStorage('clickId');
      const img = new Image();
      img.src = `https://utils.follow.whistle.mobi/pixel.php?click_id=${clickId}&revenue={revenue}&goal_name=Eligibility_Check`;
    };

    // Check if utm_source is 'VALUE_LEAF' and eligibility is 1
    if (utm_source === 'VALUE_LEAF' && eligibility == 1) {
      sendWhistlePixel();
    }

  }, [utm_source, eligibility]);

  return (
    <ModalWrapper>
      <div className="modal-box">
        <h2>{msg}</h2>
        <div className="modal-buttons">
          {state === 1 ? (
            <button onClick={handleProcessClick}>Process</button>
          ) : (
            <button onClick={handleOkClick}>OK</button>
          )}
        </div>
      </div>
    </ModalWrapper>
  );
};

export default Modal;
